import { api } from './api';
import type { DashboardData } from '../types';

export const dashboardService = {
  async getDashboard(): Promise<DashboardData> {
    const response = await api.get<DashboardData>('/api/dashboard');
    return response.data;
  },
};

export default dashboardService;
